import { ArrowDownIcon } from '@heroicons/react/20/solid';

import { ShiftRibbon } from '../api/types';

// Status pill at the top of a shift card. Per Figma Dev Mode these are plain
// 12px SemiBold badges with no icon — except the downward Dependability
// indicator, which carries an arrow-down glyph and a red outline.

export const DependabilityRibbon = () => (
  <span className="dashv2-ribbon type-dependability">
    <ArrowDownIcon />
    Dependability
  </span>
);

const formatHours = (hours?: number | null): string => {
  if (hours == null) return 'Starts soon';
  const rounded = Math.round(hours * 10) / 10;
  return `Starts in ${rounded}h`;
};

type Props = { ribbon: ShiftRibbon };

const StatusRibbon = ({ ribbon }: Props) => {
  switch (ribbon.type) {
    case 'needs_approval':
      return (
        <span className="dashv2-ribbon type-needs_approval">
          Needs approval
        </span>
      );
    case 'in_progress':
      return (
        <span className="dashv2-ribbon type-in_progress">In progress</span>
      );
    case 'starts_in':
      return (
        <span className="dashv2-ribbon type-starts_in">
          {formatHours(ribbon.hours)}
        </span>
      );
    default:
      return null;
  }
};

export default StatusRibbon;
